const STORAGE_KEY = "recentlyViewed";
const MAX_ITEMS = 10;

export const getRecentlyViewed = () => {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
};

export const addRecentlyViewed = (product) => {
  const existing = getRecentlyViewed();
  const filtered = existing.filter((p) => p.id !== product.id);
  const updated = [product, ...filtered].slice(0, MAX_ITEMS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
};

export const useRecentlyViewed = () => {
  return {
    products: getRecentlyViewed(),
    addProduct: addRecentlyViewed,
  };
};
